import { useState, useEffect, Suspense } from 'react';
import html2canvas from 'html2canvas';
import { useTexture } from '@react-three/drei';

const MicroficheTraySheetTexture = (props) => {

  const { canvasImgDataUrl } = props;
  const texture = useTexture(canvasImgDataUrl);

  return (
    <primitive attach="map" object={texture} />
  )
}

const MicroficheScreen = (props) => {

  const { screenContents } = props;
  const [canvasImgDataUrl, setCanvasImgDataUrl] = useState('');

  useEffect(() => {
    if (screenContents.current) {
      html2canvas(screenContents.current)
      .then((newCanvas) => {
        if (newCanvas.toDataURL().length > 120) {
          setCanvasImgDataUrl(newCanvas.toDataURL());
        }
      })
      .catch(err => console.log(err));
    }
  }, [screenContents]);

  if (canvasImgDataUrl !== '' && screenContents.current) {
    return (
      <group>
        <Suspense fallback={null}>
          <mesh position={[0, -1.45, 0.47]} rotation={[Math.PI * -0.5, 0, 0]}>
            <planeGeometry args={[2, 2]} />
            <meshBasicMaterial color={'white'} needsUpdate={true}>
              <MicroficheTraySheetTexture canvasImgDataUrl={canvasImgDataUrl} />
            </meshBasicMaterial>
          </mesh>
        </Suspense>
      </group>
    );
  } else {
    return null;
  }
}

export default MicroficheScreen;